// api/exchange-rates.ts
import { defaultApi } from '@/api';

export interface ExchangeRates {
  GBP: number;
  USD: number;
  EUR: number;
  AUD: number;
  CAD: number;
  AED: number;
  JPY: number;
  CNY: number;
  DKK: number;
  HKD: number;
  INR: number;
  NOK: number;
  QAR: number;
  SAR: number;
  SGD: number;
  SEK: number;
  ZAR: number;
  PKR: number;
  NZD: number;
}

export async function getExchangeRates() {
  const { data } = await defaultApi.get<{
    success: boolean;
    data: ExchangeRates;
  }>('/exchange-rates');
  return data.data;
}
